import React from "react"
import Countdown, { zeroPad } from "react-countdown"
import { Link } from "gatsby"
import Layout from "../Components/Layout"
import isEnded from "../utils/isEnded"
import { RaisedButton, CleanButton, GhostButton } from "../Components/Buttons"
import PreFooterImg from "../assets/images/home-pre-footer.jpg"
import TopIlliustration from "../assets/images/top-illustration.jpg"
import Logo from "../assets/svg/faktai.png"

import LrtLogo from "../assets/svg/lslogo.png"
import LrtLogoDark from "../assets/svg/lslogoba.png"

import MmoLogo from "../assets/svg/mmo-logo.svg"
import MmoLogoDark from "../assets/svg/mmo-logo-dark.svg"


import ArrowRight from "../assets/svg/arrow-right.svg"
import MmoPhoto from "../assets/images/mmo-photo.jpg"
import Deco1 from "../assets/images/deco-1.png"
import Deco2 from "../assets/images/deco-2.png"

import Place1 from "../assets/images/places/place-1.png"
import Place2 from "../assets/images/places/place-2.png"
import Place3 from "../assets/images/places/place-3.png"
import Place4 from "../assets/images/places/place-4.png"
import Place5 from "../assets/images/places/place-5.png"
import Place6 from "../assets/images/places/place-6.png"

const PLACES = [

]

const PLACESM = [

]




export default () => (
  <Layout>
    <div className="grid">
      <div className="grid--cell w-50 index--logo">
        <div className="index--logo-info">
          {/*<div>Kviečia dalyvauti</div> */}
          <div className="index--logo-info-logos">
            <a
              href="https://lrt.lt"
              target="_blank"
              rel="noopener noreferrer"
              title="LRT"
            >
              <img height="40px" src={LrtLogoDark} alt="LRT" />
            </a>

          </div>
        </div>

        <img className="first" src={Logo} alt="" />
        {/*<img src={TopIlliustration} alt="" />*/}
      </div>



      <div className="grid--cell w-50 bg-red">
        <div className="index--countdown">
          <div className="index--countdown-info">
            {/*<div>Kviečia dalyvauti</div> */}
            <div className="index--countdown-info-logos">
              <a
                href="https://lrt.lt"
                target="_blank"
                rel="noopener noreferrer"
                title="LRT"
              >
                <img height="40px" src={LrtLogo} alt="Statistikos departamentas" />
              </a>

            </div>
          </div>



          <div className="index--countdown-completed">
            <h1>
              Faktai ne gandai 2021
            </h1>
            {/*<h2><b>Rugsėjo 6 d. 8 val.</b></h2>   */}
              <RaisedButton variant="white" to="/try-start">
                Statistikos egzaminas
              </RaisedButton>
            {/* <GhostButton to="/start">Pradėti olimpiadą</GhostButton>   h1 klase buvo className="ended"  */}
          </div>




        </div>
      </div>

      <div className="dn-mobile-up tac mt-10 mb-10">
        <img src={Deco1} alt="" />
      </div>
    </div>

    <div className="grid">
      <div className="grid--cell w-67 no-border between">
        <div className="grid--cell">
          <div>
            <div className="index--about-project">
              {/*<h1>Faktai – ne gandai 2021</h1>*/}

              <div className="text-container">
                <p>
                  Ar matydamas viešojoje erdvėje pasirodančią informaciją dažnai susimąstai apie jos patikimumą? Ar moki suprasti ir interpretuoti skaičius? Ar pastebi, kas už jų slepiasi? Lietuvos statistika siekia, kad visos viešai skelbiamos naujienos būtų kuo tikslesnės.
                  <br/>
                  Tad NESIKLIAUK GANDAIS – REMKIS STATISTIKA!
                </p>

                <h2>Kas tai?</h2>
                <p>
                  Faktai – ne gandai 2021 – pirmą kartą organizuojama iniciatyva, skirta paminėti rugsėjo 6 d. – Lietuvos statistikos dieną ir Lietuvos statistikos departamento 102-ąjį gimtadienį. Šiuo egzaminu siekiame parodyti, kaip statistika atspindi mūsų kasdienį gyvenimą, padėti suprasti ir interpretuoti skaičius, didinti visuomenės statistinį raštingumą ir paskatinti rinktis tik patikimus informacijos šaltinius.
                </p>


                <h2>Kada?</h2>
                <p>
                  {
                    /*Užsiregistruok iš anksto arba birželio 4 d. nuo 8 iki 24 val.
                  užsuk į <Link to="/">mo.lrt.lt</Link> ir dalyvauk žaidynėse!

                  2021 metų MOlimpiados datą paskelbsime netrukus – sek naujienas  <Link to="https://mo.lt">mo.lt</Link>

                  Užsiregistruok iš anksto arba balandžio 22 d. nuo 8 iki 24 val.
                  užsuk į <Link to="/">mo.lrt.lt</Link> ir dalyvauk meno nuotykyje!
*/
                  }
                  Egzaminas vyks 2021 m. rugsėjo 6 d. 8.00–22.00 val.


                </p>
                <p>
                  Pasitikrinti statistikos žinias bus galima ir pasibaigus egzaminui – testas bus aktyvus iki rugsėjo 30 d. 24.00 val.
                </p>



                <h2>Kas gali dalyvauti?</h2>
                <p>
                  Egzamine kviečiame dalyvauti visus, kurie nori geriau suprasti statistiką ir žinoti daugiau. Nėra jokių amžiaus apribojimų. Tiesa, klausimai labiau orientuoti į vyresniųjų klasių moksleivius, studentus, suaugusiuosius.
                </p>


                <h2>Ko reikia, kad galėtum dalyvauti egzamine?</h2>
                <p>
                  Svarbiausia – turėti mobilųjį telefoną, kompiuterį ar kitą išmanųjį įrenginį, kuris palaiko interneto ryšį. Prisijunk prie www.faktainegandai.lrt.lt.      <br/>
                  Spausk „Dalyvauti egzamine“. <br/>
                  Atsakyk į klausimus ir sužinok savo statistikos žinių lygį.<br/>
              </p>

                <h2>Klausimai</h2>
                <p>
                  Egzamino klausimus parengėme pagal Oficialiosios statistikos portale osp.stat.gov.lt skelbiamus rodiklius, statistinius tyrimus. Testą sudaro 30 klausimų, kurie suskirstyti pagal temas – nuo demografinių šalies rodiklių iki su COVID-19 susijusių statistinių duomenų bei bendrųjų klausimų. Kad būtų drąsiau ir lengviau atsakinėti į pateiktus klausimus, galite pasižiūrėti skyrelyje „Pažintis su statistika“.
                </p>

                <h2>Ką gali laimėti?</h2>
                <p>
                  102 daugiausiai taškų surinkę egzamino dalyviai bus apdovanoti „Statistikos ekspertų“ sertifikatu bei Lietuvos statistikos įsteigtais prizais. Su daugiausia taškų surinkusiais egzamino dalyviais susisieksime registracijos metu nurodytu elektroniniu paštu. Prizai bus atsiųsti paštu.
                </p>
                <p>
                  Taškai skiriami ne tik už teisingą atsakymo variantą, bet ir atsakymų laiką – kuo greitesni atsakymai, tuo daugiau taškų!
                </p>

                  <p>
                    Jei turite klausimų, bendraukime:<br/>
                    info@stat.gov.lt<br/>
                    85 236 4888<br/>
                    https://fb.com/Lietuvosstatistikos <br/>
                    #faktainegandai
                  </p>

              </div>


            </div>
          </div>


        </div>




      </div>


    </div>


  </Layout>
)
